import { render, staticRenderFns } from "./CustomProductForm.vue?vue&type=template&id=9af3948a&scoped=true&lang=html&"
import script from "./CustomProductForm.vue?vue&type=script&lang=js&"
export * from "./CustomProductForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductForm.vue?vue&type=style&index=0&id=9af3948a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af3948a",
  null
  
)

export default component.exports